import { format, addMinutes } from 'date-fns';

/**
 * Generates calendar links for Google, Apple (ICS), and Outlook
 */
export const generateCalendarLinks = (booking) => {
  if (!booking) return { google: '', outlook: '', apple: '' };
  
  const { booking_date, booking_time, service, customer, address } = booking;
  const startStr = `${booking_date}T${booking_time}`;
  const startDate = new Date(startStr);
  
  // Default duration 45 mins if not specified
  const durationMatch = service?.duration?.match(/(\d+)/);
  const duration = durationMatch ? parseInt(durationMatch[0]) : 45;
  const endDate = addMinutes(startDate, duration);

  const title = `Grooming: ${service?.name || 'Appointment'} - ${customer?.full_name || 'Client'}`;
  const description = `BookOTG Appointment\nClient: ${customer?.full_name}\nService: ${service?.name}\nAddress: ${address}\nPhone: ${customer?.phone}`;
  const location = address;

  const fmt = (date) => format(date, "yyyyMMdd'T'HHmmss'Z'");

  // Google Calendar
  const google = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${fmt(startDate)}/${fmt(endDate)}&details=${encodeURIComponent(description)}&location=${encodeURIComponent(location)}`;

  // Outlook / Office 365
  const outlook = `https://outlook.office.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(title)}&startdt=${format(startDate, "yyyy-MM-dd'T'HH:mm:ss")}&enddt=${format(endDate, "yyyy-MM-dd'T'HH:mm:ss")}&body=${encodeURIComponent(description)}&location=${encodeURIComponent(location)}`;

  // Apple / ICS (Data URI)
  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'BEGIN:VEVENT',
    `DTSTART:${fmt(startDate)}`,
    `DTEND:${fmt(endDate)}`,
    `SUMMARY:${title}`,
    `DESCRIPTION:${description}`,
    `LOCATION:${location}`,
    'END:VEVENT',
    'END:VCALENDAR'
  ].join('\n');
  
  const apple = `data:text/calendar;charset=utf-8,${encodeURIComponent(icsContent)}`;

  return { google, outlook, apple };
};